import get from 'lodash.get';
import includes from 'lodash.includes';
import { getRetailPrice } from 'dibs-selectors/dist/item';
import { getAmountByCurrency } from 'dibs-selectors/dist/amount';
import { shipping } from './verifiedTradePromoConstants.es';

export const promoCoversShipping = shippingAmount => getAmountByCurrency(shippingAmount)('USD') <= shipping.amounts.PROMO_AMOUNT_USD;

export const applyPromo = ({user = {}, item = {}, confirmedTransactions = {}} = {}) => {
    const { isVerifiedTrade, verifiedTradeSubStatus } = user;
    const { totalResults = 0 } = confirmedTransactions;
    const itemPriceUSD = get(getRetailPrice(item), 'amount.convertedAmounts.USD');

    return isVerifiedTrade && includes(verifiedTradeSubStatus, 'VERIFIED_IN_LAST_30_DAYS') && totalResults === 0 && itemPriceUSD >= shipping.amounts.MIN_ITEM_PRICE_USD;
};



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Shipping/VerifiedTradePromo/verifiedTradePromoHelpers.es.js